import { render, staticRenderFns } from "./ProfileInternalSection.vue?vue&type=template&id=6882fce8&scoped=true&"
import script from "./ProfileInternalSection.vue?vue&type=script&lang=js&"
export * from "./ProfileInternalSection.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInternalSection.vue?vue&type=style&index=0&id=6882fce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6882fce8",
  null
  
)

export default component.exports